import { useCallback } from 'react'
import { useNotifier } from '@cbgms/base/notifier'
import { useTranslation } from 'react-i18next'
import { IConcept, POSTConceptResponse } from '@cbgms/api/modules/concepts'
import { generateSubmissionError } from 'utils-support/Form/SubmissionError'
import { createConcept } from 'app-support/concepts/state/actions'
import ConceptForm from './Form'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

const FORM_NAME = 'concepts_new'
const defaultInitialValues: IConcept = {
  UUID: '',
  Name: '',
  SubscriptionKey: '',
  SubscriptionKeyAppointment: '',
  SubscriptionKeyFrontOffice: '',
  ConceptNumber: '',
  IFrameIsSupported: false,
  IFrameTermsAndConditions: '',
  CreatedAt: '',
  UpdatedAt: ''
}

const NewConcept = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const notifier = useNotifier()
  const dispatch = useDispatch()

  const onSubmit = useCallback(
    async (values: IConcept) => {
      try {
        const { Data } = (await dispatch(createConcept(values))) as any as POSTConceptResponse
        return { ...values, UUID: Data.UUID }
      } catch (error) {
        throw generateSubmissionError(error)
      }
    },
    [dispatch]
  )

  const onSubmitSuccess = useCallback(
    (v: IConcept) => {
      notifier.success(t('Concepts.CreatedSuccessfully'))
      history.push(`/concepts/edit/${v.UUID}`)
    },
    [notifier]
  )

  return <ConceptForm form={FORM_NAME} initialValues={defaultInitialValues} onSubmit={onSubmit} onSubmitSuccess={onSubmitSuccess} />
}

export default NewConcept
